import { render } from "./cookiesModal.vue?vue&type=template&id=53570838&scoped=true"
import script from "./cookiesModal.vue?vue&type=script&lang=js"
export * from "./cookiesModal.vue?vue&type=script&lang=js"

import "./cookiesModal.vue?vue&type=style&index=0&id=53570838&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53570838"]])

export default __exports__